var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "card" },
      [
        _c(
          "div",
          {
            staticClass:
              "card-header d-flex justify-content-between align-items-center"
          },
          [
            _c("h4", { staticClass: "card-title mb-0" }, [
              _vm._v("Mis Tipos de Documentos")
            ]),
            _c(
              "div",
              { staticClass: "d-flex gap-2 align-items-center" },
              [
                _vm.totalCount > 0
                  ? _c("span", { staticClass: "text-muted small" }, [
                      _vm._v(
                        " Mostrando " +
                          _vm._s(_vm.documentTypes.length) +
                          " de " +
                          _vm._s(_vm.totalCount) +
                          " tipos de documentos "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.loading
                    },
                    on: { click: _vm.refreshList }
                  },
                  [
                    !_vm.loading
                      ? _c("feather-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "RefreshCwIcon" }
                        })
                      : _c("span", {
                          staticClass: "spinner-border spinner-border-sm mr-1",
                          attrs: { role: "status" }
                        }),
                    _vm._v(" Actualizar ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            !_vm.loading && _vm.documentTypes.length === 0
              ? _c(
                  "div",
                  { staticClass: "text-center py-5" },
                  [
                    _c("feather-icon", {
                      staticClass: "text-muted mb-3",
                      attrs: { icon: "FileTextIcon", size: "64" }
                    }),
                    _c("h5", { staticClass: "text-muted" }, [
                      _vm._v("No hay tipos de documentos disponibles")
                    ]),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        "No se encontraron tipos de documentos en el sistema."
                      )
                    ])
                  ],
                  1
                )
              : _c("b-table", {
                  attrs: {
                    items: _vm.documentTypes,
                    fields: _vm.fields,
                    busy: _vm.loading,
                    "empty-text": _vm.emptyText,
                    responsive: "sm",
                    striped: "",
                    hover: "",
                    "show-empty": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(tipoId)",
                      fn: function(row) {
                        return [_c("strong", [_vm._v(_vm._s(row.item.tipoId))])]
                      }
                    },
                    {
                      key: "cell(nombre)",
                      fn: function(row) {
                        return [_vm._v(" " + _vm._s(row.item.nombre) + " ")]
                      }
                    },
                    {
                      key: "cell(descripcion)",
                      fn: function(row) {
                        return [
                          row.item.descripcion
                            ? _c("span", [_vm._v(_vm._s(row.item.descripcion))])
                            : _c("span", { staticClass: "text-muted" }, [
                                _vm._v("—")
                              ])
                        ]
                      }
                    },
                    {
                      key: "cell(activo)",
                      fn: function(row) {
                        return [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: row.item.activo
                                  ? "success"
                                  : "secondary"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.item.activo ? "Activo" : "Inactivo"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(actions)",
                      fn: function(row) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex gap-1" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-primary",
                                    title: "Ver detalles"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.viewDocumentTypeDetails(
                                        row.item
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "EyeIcon", size: "16" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
            _vm.totalPages > 1
              ? _c("b-pagination", {
                  staticClass: "mt-3",
                  attrs: {
                    "total-rows": _vm.totalCount,
                    "per-page": _vm.perPage,
                    "aria-controls": false,
                    align: "center",
                    size: "sm"
                  },
                  on: { input: _vm.onPageChange },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "b-modal",
          {
            attrs: { title: _vm.modalTitle, size: "lg", centered: "" },
            scopedSlots: _vm._u([
              {
                key: "modal-footer",
                fn: function(ref) {
                  var ok = ref.ok
                  var cancel = ref.cancel
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary" },
                        on: { click: cancel }
                      },
                      [_vm._v("Cerrar")]
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.showDetailModal,
              callback: function($$v) {
                _vm.showDetailModal = $$v
              },
              expression: "showDetailModal"
            }
          },
          [
            _vm.selectedDocumentType
              ? _c("div", [
                  _c("dl", { staticClass: "row mb-0" }, [
                    _c("dt", { staticClass: "col-sm-3" }, [_vm._v("ID Tipo")]),
                    _c("dd", { staticClass: "col-sm-9" }, [
                      _vm._v(_vm._s(_vm.selectedDocumentType.tipoId))
                    ]),
                    _c("dt", { staticClass: "col-sm-3" }, [_vm._v("Nombre")]),
                    _c("dd", { staticClass: "col-sm-9" }, [
                      _vm._v(_vm._s(_vm.selectedDocumentType.nombre))
                    ]),
                    _c("dt", { staticClass: "col-sm-3" }, [
                      _vm._v("Descripción")
                    ]),
                    _c("dd", { staticClass: "col-sm-9" }, [
                      _vm.selectedDocumentType.descripcion
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedDocumentType.descripcion) +
                                " "
                            )
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("—")
                          ])
                    ]),
                    _c("dt", { staticClass: "col-sm-3" }, [_vm._v("Estado")]),
                    _c(
                      "dd",
                      { staticClass: "col-sm-9" },
                      [
                        _c(
                          "b-badge",
                          {
                            attrs: {
                              variant: _vm.selectedDocumentType.activo
                                ? "success"
                                : "secondary"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedDocumentType.activo
                                    ? "Activo"
                                    : "Inactivo"
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("dt", { staticClass: "col-sm-3" }, [
                      _vm._v("Fecha Creación")
                    ]),
                    _c("dd", { staticClass: "col-sm-9" }, [
                      _vm.selectedDocumentType.fechaCreacion
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatDate(
                                    _vm.selectedDocumentType.fechaCreacion
                                  )
                                ) +
                                " "
                            )
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("—")
                          ])
                    ]),
                    _c("dt", { staticClass: "col-sm-3" }, [
                      _vm._v("Entidad Asociada")
                    ]),
                    _c("dd", { staticClass: "col-sm-9" }, [
                      _vm.selectedDocumentType.entidad
                        ? _c("div", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedDocumentType.entidad.entidadNombre
                                )
                              )
                            ]),
                            _c("br"),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                " ID Entidad: " +
                                  _vm._s(
                                    _vm.selectedDocumentType.entidad.entidadId
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("—")
                          ])
                    ])
                  ])
                ])
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }